import React from 'react'

export default function RegisterProductFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #new-record-count-container {
          display: flex;
          flex: 3;
          font-size: 0.65em;
          justify-contents: center;
        }

        #new-record-count {
          border-radius: 3px;
          /*border: 1px solid lightblue;*/
          /*background-color: rgba(15, 13, 150, 1);*/
          color: rgba(19, 19, 119, 1);
          padding: 0 7px;
          margin: auto 0;
          padding-bottom: 5px;
        }

        .notification {
          /*border: 1px solid lightblue;*/
          /*border-radius: 3px;*/
          /*background-color: rgba(8, 80, 10, 1);*/
          padding: 0 7px;
          padding-bottom: 5px;
          margin: auto 0;
        }

        .regprod-button-container {
          display: flex;
          justify-content: flex-end;
          padding: 5px;
        }

        #save-item-btn, #products-list-btn {
        }
      `}
      </style>
    </React.Fragment>
  )
}
